/* eslint-disable */
import { getLocalUser } from './helpers/auth'

const user = getLocalUser()

export default {
  state: {
      currentUser: user,
      isLoggedin: !!user,
      loading: false,
      auth_error: null,
      collaborators: []
  },
  getters: {
    isLoading(state) {
      return state.loading
    },
    isLoggedin(state) {
      return state.isLoggedin
    },
    currentUser(state) {
      return state.currentUser
    },
    authError(state) {
      return state.auth_error
    },
    collaborators(state) {
      return state.collaborators
    }
  },
  mutations: {
    login(state) {
      state.loading = true
      state.auth_error = null
    },
    loginSuccess(state, payload) {
      state.auth_error = null
      state.isLoggedin = true
      state.loading = false
      state.currentUser = Object.assign({}, payload.user, {token: payload.access_token})

      localStorage.setItem("user", JSON.stringify(state.currentUser))
    },
    alterUserData(state, payload) {
      localStorage.setItem("user", JSON.stringify(payload))
    },
    loginFailed(state, payload) {
      state.loading = false
      state.auth_error = payload.error
    },
    logout(state) {
      localStorage.removeItem("user")
      state.isLoggedin = false
      state.currentUser = null
    },
    updateCollaborators(state, payload) {
      state.collaborators = payload
    }
  },
  actions: {
    login(context) {
      context.commit("login")
    },
    getCollaborators(context, payload) {
      return axios.get(`collaborator/manager/collaborators`)
      .then((response) => {
        context.commit('updateCollaborators', response.data)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store.js